import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: "100vh"
  },
  box: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '400px',
    height: '400px',
    margin: '0 20px',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.2)',
    },
    overflow: 'hidden',
  },
  coloredDiv: {
    height: '15px',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
  header: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  number: {
    fontSize: '100px',
    fontWeight: 'bold',
    lineHeight: '1',
    textAlign: 'center',
    marginBottom: '20px',
  },
  image: {
    width: '150px',
    height: '150px',
    marginBottom: '20px',
  },
  text: {
    textAlign: 'left',
    fontSize: '16px',
  },
}));

const CardCustom = ({ header, text1, text2, backgroundColor, number }) => {
  const classes = useStyles();
  return (
    <Grid item className={classes.box}>
      <div className={classes.coloredDiv} style={{ backgroundColor }} />
      {/* <img src={image} alt={header} className={classes.image}/> */}
      <Typography className={classes.number} style={{ color: backgroundColor }}>{number}</Typography>
      <Typography variant="h5">{header}</Typography>
      <br />
      <Typography variant="body1" className={classes.text}>
        <p>{text1}</p>
        <p>{text2}</p>
      </Typography>
    </Grid>
  );
};

const OnboardingPageExplainProcess = () => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '80vh' }}>
      <Typography variant="h4" align="center" gutterBottom>
        <IntlMessages id="ui.setupVisualRecs.onboardingPageExplainProcess.integrationProcess" />
      </Typography>
      <div className={classes.container}>
        <CardCustom
          header={<IntlMessages id="onboarding.visualRecs.process.training.title" />}
          backgroundColor="var(--kea-color-primary-soft)"
          image="https://via.placeholder.com/150"
          number="1"
          text1={<IntlMessages id="onboarding.visualRecs.process.training.description" />}
          text2={<IntlMessages id="onboarding.visualRecs.process.training.duration" />}
        />
        <CardCustom
          header={<IntlMessages id="onboarding.visualRecs.process.placement.title" />}
          backgroundColor="var(--kea-color-primary)"
          image="https://via.placeholder.com/150"
          number="2"
          text1={<IntlMessages id="onboarding.visualRecs.process.placement.description" />}
          text2={<IntlMessages id="onboarding.visualRecs.process.placement.design" />}
        />
        <CardCustom
          header={<IntlMessages id="onboarding.visualRecs.process.preview.title" />}
          backgroundColor="#1E2248"
          image="https://via.placeholder.com/150"
          number="3"
          text1={<IntlMessages id="onboarding.visualRecs.process.preview.description" />}
          text2={<IntlMessages id="onboarding.visualRecs.process.preview.visibility" />}
        />
      </div>
    </Grid>
  );
};

export default OnboardingPageExplainProcess;
